import DOMPurify from "dompurify";
import { ElementType, ReactElement } from "react";

/**
 * The ONLY place in the app that renders authored HTML. Paragraph/header/list/table text
 * carries inline markup from the Diapason editor (<b>/<i>/<u>/<mark class="cdx-marker">/
 * <a>); everything else is stripped. Keep every dangerouslySetInnerHTML behind this
 * component so the sanitization policy has a single source of truth.
 */
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ["b", "i", "strong", "em", "u", "mark", "a", "br", "code", "span"],
  // `class` stays: the marker tool emits <mark class="cdx-marker"> (styled in the renderer)
  ALLOWED_ATTR: ["href", "class"],
};

// Authored links always open outside the flow (and never inherit the app's opener).
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

interface InlineHtmlProps {
  html?: string;
  as?: ElementType;
  className?: string;
}

const InlineHtml = ({ html, as: Tag = "span", className }: InlineHtmlProps): ReactElement => (
  <Tag
    className={className}
    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html ?? "", SANITIZE_CONFIG) }}
  />
);

export default InlineHtml;
